export const hasGon = <GonType = any>(
  window: Window
): window is WindowWithGon<GonType> =>
  window.hasOwnProperty('gon') && (window as any).gon !== undefined;
